import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import { removeUserSession } from "../utils/comman/Common";

// export const baseURL = process.env.REACT_APP_BASE_URL;
export const baseURL =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_BASE_URL
    : `${window.location.origin}/`;
const userId = JSON.parse(sessionStorage.getItem("uid"));
let headers = {};

const axiosinstances = (ipAddress) => {
  const token = sessionStorage.getItem("token");
  // const navigate = useNavigate();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const axiosInstance = axios.create({
    baseURL: baseURL,
    timeout: 50000,
    headers: { "X-Custom-Header": "foobar", ...headers },
  });

  //   // Add IP to every request
  axiosInstance.interceptors.request.use(
    (config) => {
      if (ipAddress) {
        const hasQueryParams = config.url.includes("?");
        config.url += hasQueryParams ? `&ip=${ipAddress}` : `?ip=${ipAddress}`;
      }
      if (userId) {
        const hasQueryParams = config.url.includes("?");
        config.url += hasQueryParams ? `&user=${userId}` : `?user=${userId}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  // client.interceptors.response.use(undefined, err => {})
  axiosInstance.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const errormsg = error.response?.data?.message;
      const isUnauthorized =
        errormsg !== undefined ? errormsg.includes("401 Unauthorized") : false;
      if (error.response.status === 401) {
        removeUserSession();
        alert("Your session has expired, plz login again");
        window.location.reload();
      } else if (error.response.status === 500 && isUnauthorized) {
        setTimeout(() => {
          window.location.href = "/";
          sessionStorage.removeItem("token");
        }, [2000]);
      }
      return error;
    }
  );

  return [axiosInstance];
};

export default axiosinstances;

// import axios from "axios";
// import "bootstrap/dist/css/bootstrap.css";

// export const baseURL = process.env.REACT_APP_BASE_URL;
// const ERR_BAD_REQUEST = "ERR_BAD_REQUEST";

// const axiosinstances = (ipAddress) => {
//   const token = sessionStorage.getItem("token");

//   let headers = {};
//   if (token) {
//     headers.Authorization = `Bearer ${token}`;
//   }

//   const axiosInstance = axios.create({
//     baseURL: baseURL,
//     timeout: 50000,
//     headers: { "X-Custom-Header": "foobar", ...headers },
//   });

//   // Add IP to every request
//   axiosInstance.interceptors.request.use(
//     (config) => {
//       if (ipAddress) {
//         const hasQueryParams = config.url.includes("?");
//         config.url += hasQueryParams ? `&ip=${ipAddress}` : `?ip=${ipAddress}`;
//       }
//       return config;
//     },
//     (error) => Promise.reject(error)
//   );

//   // Handle Responses
//   axiosInstance.interceptors.response.use(
//     (response) => response,
//     (error) => {
//       console.log("error1", error);
//       const errormsg = error.response?.data?.message;
//       const isUnauthorized =
//         errormsg !== undefined ? errormsg.includes("401 Unauthorized") : false;

//       if (
//         error.response?.status === 401 &&
//         error?.code === ERR_BAD_REQUEST &&
//         error?.response?.data?.error !== undefined
//       ) {
//         console.log(error?.response?.data?.error);
//       } else if (error.response.status === 500 && isUnauthorized) {
//         window.location.href = "/";
//         sessionStorage.removeItem("token");
//       }

//       return Promise.reject(error);
//     }
//   );

//   return axiosInstance;
// };

// export default axiosinstances;
